async function updateLoanUploadLog(
  user,
  logEntry,
  loan,
  setCurrentLoan = false
) {
  // for security reasons to compare those value on backend
  // const targetUrl = `${process.env.CMS_URL}/tours/${tour.id}/?TourID=${tour.id}&UserType=${userType}&UrlAddress=${tour.UrlAddress}`;
  // all the query params need to be provided

  const targetUrl = `${process.env.CMS_URL}/loans/${loan.id}`;
  const token = await user.getIdToken();
  // dataTranslation
  const res = await fetch(targetUrl, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    // this call works diff then other calls
    // because we only pass back atomic information that changed
    body: JSON.stringify({
      UploadLogEntry: logEntry,
    }),
  });

  const respJSON = await res.json();

  if (setCurrentLoan) {
    setCurrentLoan(respJSON);
  }

  return respJSON;
}

export default updateLoanUploadLog;
